module.exports = __webpack_public_path__ + "static/media/ic-star-filled.ed8dbc89.svg";